import React, { FC } from 'react'
import styled from 'styled-components'

import { TextSpan } from 'Components/TextSpan'
import { CurrencyText } from 'Components/Text/CurrencyText'
import { RolloverChip } from 'Components/Chip/RolloverChip'
import { OngoingPurchasesChip } from 'Components/Chip/OngoingPurchasesChip'

import {
  BenefitProgramPolicy,
  hasRollover,
  policyPeriodSummary
} from 'Utils/types/benefitProgramPolicy'
import { CurrencyCode } from 'Utils/types/currencies'
import { displayDate } from 'Utils/helpers/dateUtils'
import { FlexColumn, FlexRow, spacingXS, spacingXXS } from 'Utils/styles/spacing'
import { fontSizeSM, fontSizeXS, fontWeightBold, fontWeightNormal } from 'Utils/styles/text'
import { azure, electricViolet, mineralGreen, zirconGray } from 'Utils/styles/colors'

const PolicyCard = styled.div`
  background-color: ${azure};
  border: 1px solid ${zirconGray};
  border-left: 3px solid ${electricViolet};
  border-radius: 4px;
  padding: ${spacingXS};
`

const PolicyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacingXXS};
`

const DetailRow = styled(FlexRow)`
  justify-content: space-between;
  align-items: baseline;
`

const Label = styled.span`
  font-size: ${fontSizeXS};
  font-weight: ${fontWeightNormal};
  color: ${mineralGreen};
`

type FuturePolicyDisplayProps = {
  policy: BenefitProgramPolicy
  currencyCode: CurrencyCode
}

export const FuturePolicyDisplay: FC<FuturePolicyDisplayProps> = ({ policy, currencyCode }) => {
  return (
    <PolicyCard>
      <FlexColumn gap={spacingXXS}>
        <PolicyHeader>
          <TextSpan fontWeight={fontWeightBold} fontSize={fontSizeSM}>
            Starts {displayDate(policy.scheduledStartDate)}
          </TextSpan>
        </PolicyHeader>

        <DetailRow gap={spacingXS}>
          <Label>Allowance:</Label>
          <TextSpan fontWeight={fontWeightBold} fontSize={fontSizeSM}>
            <CurrencyText
              value={policy.expenditureAllowance}
              currencyCode={currencyCode}
              showMinorUnit={false}
            />
            {' / '}
            {policyPeriodSummary(policy)}
          </TextSpan>
        </DetailRow>

        <FlexRow gap={spacingXXS} style={{ marginTop: spacingXXS }}>
          {hasRollover(policy) && <RolloverChip />}
          {policy.ongoingPurchases && <OngoingPurchasesChip />}
        </FlexRow>
      </FlexColumn>
    </PolicyCard>
  )
}
